(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muavi-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muavi-hero-slideshow')) {
    customElements.define('muavi-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.toggle = this.querySelector('[data-hero-toggle]');
        this.stage = this.querySelector('.muavi-hero__stage');
        this.status = this.querySelector('[data-hero-status]');
        if (this.slides.length < 2 || !this.toggle) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches;
        this.pointerPaused = false;
        this.focusPaused = this.stage.contains(document.activeElement);
        this.editorPaused = false;
        this.transitionId = 0;
        this.activeIndex = Math.max(0, this.slides.findIndex(slide => slide.dataset.active === 'true'));
        this.slides.forEach(slide => { slide.hidden = false; });
        this.querySelector('[data-hero-controls]').hidden = false;

        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updateToggle();
          this.schedule();
        }, options);
        this.stage.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.pointerPaused = true;
          this.schedule();
        }, options);
        this.stage.addEventListener('pointerleave', () => {
          this.pointerPaused = false;
          this.schedule();
        }, options);
        this.stage.addEventListener('focusin', () => {
          this.focusPaused = true;
          this.schedule();
        }, options);
        this.stage.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.isConnected) return;
            this.focusPaused = this.stage.contains(document.activeElement);
            this.schedule();
          });
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', event => {
          if (event.matches) this.userPaused = true;
          this.updateToggle();
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.editorPaused = true;
          this.selectSlide(index);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail?.blockId)) return;
          this.editorPaused = false;
          this.schedule();
        }, options);

        this.paintSlide(this.activeIndex);
        this.updateToggle();
        this.schedule();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.controller?.abort();
        this.transitionId += 1;
      }

      get paused() {
        return this.userPaused || this.pointerPaused || this.focusPaused || this.editorPaused || document.hidden;
      }

      updateToggle() {
        this.toggle.dataset.paused = String(this.userPaused);
        const label = this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.textContent = label;
      }

      schedule() {
        window.clearTimeout(this.timer);
        if (!this.isConnected || this.paused) return;
        this.timer = window.setTimeout(() => {
          this.selectSlide((this.activeIndex + 1) % this.slides.length, true);
        }, 8000);
      }

      async selectSlide(index, automatic = false) {
        if (!this.slides[index]) return;
        window.clearTimeout(this.timer);
        const transitionId = ++this.transitionId;
        const image = this.slides[index].querySelector('img');
        if (image && !image.complete) {
          image.loading = 'eager';
          try { await image.decode(); } catch { }
        }
        if (!this.isConnected || transitionId !== this.transitionId) return;
        if (automatic && this.paused) return;
        if (image && !image.naturalWidth) {
          this.schedule();
          return;
        }
        this.paintSlide(index);
        if (!automatic && this.status) this.status.textContent = this.slides[index].dataset.title;
        this.schedule();
      }

      paintSlide(index) {
        this.activeIndex = index;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.dataset.active = String(active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
